import objectPath from 'object-path'

export const FAVORITE_SUGGESTION_SCOPES = ['public', 'me']

const hasValue = (value) =>
  value !== undefined && value !== null && `${value}`.trim() !== ''

export const normalizeFavoriteTemplateRows = (responseData) => {
  const root = responseData?.data || responseData || {}

  if (Array.isArray(root)) return root
  if (Array.isArray(root?.data)) return root.data

  const keys = ['favoriteTemplates', 'templates', 'items', 'rows', 'list']

  for (const key of keys) {
    if (Array.isArray(root?.[key])) return root[key]
    if (Array.isArray(root?.data?.[key])) return root.data[key]
  }

  return []
}

export const mergeFavoriteTemplateRows = (templateLists = []) => {
  const favoriteMap = new Map()

  templateLists.flat().forEach((template) => {
    if (!template) return
    const key =
      template.favoriteTemplateId != null
        ? `id-${template.favoriteTemplateId}`
        : `name-${template.name || ''}-${JSON.stringify(template.jsonData || {})}`
    if (!favoriteMap.has(key)) {
      favoriteMap.set(key, template)
    }
  })

  return Array.from(favoriteMap.values())
}

export const filterFavoriteTemplatesByKeyword = (
  favoriteTemplates = [],
  keyword = '',
) => {
  const keywordText = `${keyword || ''}`.trim().toLowerCase()
  if (!keywordText) return []

  return favoriteTemplates.filter((template = {}) =>
    `${template.name || ''}`.toLowerCase().includes(keywordText),
  )
}

export const parseFavoriteJsonData = (jsonData) => {
  if (!jsonData) return {}
  if (typeof jsonData === 'object') return jsonData

  try {
    return JSON.parse(jsonData)
  } catch (error) {
    return {}
  }
}

export const formatFavoriteSuggestionValue = (value) => {
  if (value === undefined || value === null) return ''
  if (!hasValue(value) && typeof value !== 'object') return ''

  if (Array.isArray(value)) {
    return value
      .map((item) => formatFavoriteSuggestionValue(item))
      .filter(hasValue)
      .join('\n')
  }

  if (value && typeof value === 'object') {
    return Object.values(value)
      .map((item) => formatFavoriteSuggestionValue(item))
      .filter(hasValue)
      .join(' ')
  }

  return `${value}`
}

export const getFavoriteTemplateSuggestionValue = (
  template = {},
  uischema = {},
  favoriteSetting = {},
) => {
  const jsonData = parseFavoriteJsonData(template.jsonData)
  const jsonDataMap =
    objectPath.get(uischema, 'favorite.jsonData') ||
    objectPath.get(favoriteSetting, 'jsonData') ||
    {}
  const favoriteJsonName =
    objectPath.get(uischema, 'favorite.jsonName') ||
    objectPath.get(favoriteSetting, 'jsonName')
  const dataName =
    objectPath.get(jsonDataMap, uischema.key) ||
    objectPath.get(jsonDataMap, uischema.name) ||
    Object.values(jsonDataMap)[0]
  const value =
    (favoriteJsonName && objectPath.get(jsonData, favoriteJsonName)) ||
    objectPath.get(jsonData, dataName)

  return formatFavoriteSuggestionValue(value)
}

export const insertSuggestionValue = (
  value = '',
  selection = {},
  replacement = '',
) => {
  const text = `${value || ''}`
  const currentSelection = selection || {}
  const start = Math.max(
    0,
    Math.min(currentSelection.start ?? text.length, text.length),
  )
  const end = Math.max(
    start,
    Math.min(currentSelection.end ?? start, text.length),
  )
  const nextValue = `${text.slice(0, start)}${replacement}${text.slice(end)}`
  const selectionStart = start + `${replacement || ''}`.length

  return {
    value: nextValue,
    selectionStart,
  }
}
